import React from "react";

const NotFound = () => {

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>404</h1>
            <p style={styles.message}>
                Oops! La página que buscas no existe. <br /> Tal vez te perdiste por el camino.
            </p>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f9f9f9",
        color: "#333",
        fontFamily: "'Roboto', sans-serif",
        textAlign: "center",
    },
    title: {
        fontSize: "6rem",
        margin: "0",
        color: "#ff6f61",
    },
    message: {
        fontSize: "1.5rem",
        margin: "20px 0",
        color: "#555",
    },
    button: {
        padding: "10px 20px",
        fontSize: "1rem",
        backgroundColor: "#ff6f61",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
    buttonHover: {
        backgroundColor: "#ff4c3b",
    },
};

export default NotFound;